
export default class MemberChangePrimaryPasswordRequestModel {
    public backupPassword: string = '';
    public newPrimaryPassword: string = '';
    public currentPrimaryPassword: string = '';
}
